import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import CookiePopup from './components/CookiePopup';
import AgeVerification from './components/AgeVerification';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Comparison from './pages/Comparison';
import Bwin from './pages/offers/Bwin';
import Genybet from './pages/offers/Genybet';
import NetBet from './pages/offers/NetBet';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsConditions from './pages/TermsConditions';
import ResponsibleGaming from './pages/ResponsibleGaming';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="warning">
          <p>
            JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.{' '}
            RETROUVEZ NOS CONSEILS SUR{' '}
            <a href="https://www.joueurs-info-service.fr/" target="_blank" rel="noopener noreferrer">
              JOUEURS-INFO-SERVICE.FR
            </a>{' '}
            (09 74 75 13 13 - APPEL NON SURTAXÉ)
          </p>
        </div>
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apropos" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/comparaison" element={<Comparison />} />
            <Route path="/offres/bwin" element={<Bwin />} />
            <Route path="/offres/genybet" element={<Genybet />} />
            <Route path="/offres/netbet" element={<NetBet />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/politique-cookies" element={<CookiePolicy />} />
            <Route path="/conditions-generales" element={<TermsConditions />} />
            <Route path="/jeu-responsable" element={<ResponsibleGaming />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <CookiePopup />
        <AgeVerification />
        <BackToTop />
      </Router>
    </HelmetProvider>
  );
}

export default App;
